import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addReturnInfo"`}</inlineCode>{` - Required`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`returnDate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#datetime"
          }}>{`DateTime`}</a>{` - Optional`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`returnTrackingId`}</inlineCode>{` - String - Optional`}<br parentName="li"></br>
          {`Identifies which return tracking ID is connected to this particular return.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`items`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#returnitemdraft"
          }}>{`ReturnItemDraft`}</a>{` - Required`}<br parentName="li"></br>
          {`Items to be returned.`}</li>
      </ul>
      <p parentName="section">{`This update action produces a `}<a parentName="p" {...{
          "href": "/api/../api/projects/messages#return-info-added"
        }}>{`ReturnInfoAdded`}</a>{` Message.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      